import { render, staticRenderFns } from "./columnsModal.vue?vue&type=template&id=34a3a56a&"
import script from "./columnsModal.vue?vue&type=script&lang=js&"
export * from "./columnsModal.vue?vue&type=script&lang=js&"
import style0 from "./columnsModal.vue?vue&type=style&index=0&id=34a3a56a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports